<!-- 联盟成员的内部管理人员列表 -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.addStaff" @click="dialogStaffVisible = true">添加人员</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">员工名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.StaffName" placeholder="请输入员工名称"></el-input>
                <div class="search-name">加入时间</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="handleChange"
                    size="small"
                    class="search-name"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                    <el-table-column min-width="160px" prop="StaffName" label="联盟参与人" show-overflow-tooltip> </el-table-column>
                    <el-table-column min-width="160px" prop="JobNum" label="员工工号" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="160px" prop="Position" label="职位" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="160px" prop="PhoneNum" label="联系电话" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="160px" prop="JoinTime" label="加入时间" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100" prop="IsAdmin" label="是否管理员" show-overflow-tooltip
                        ><template slot-scope="scope">{{ scope.row.IsAdmin ? '是' : '否' }}</template></el-table-column
                    >
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="staffAuthEdit(scope.row)" v-if="permission.assignPermissions && !scope.row.IsAdmin">{{
                                    permission.assignPermissions
                                }}</el-button>
                                <el-button
                                    type="text"
                                    size="mini"
                                    style="color: red"
                                    @click="removeOut(scope.row)"
                                    v-if="permission.removeOut && !scope.row.IsAdmin && !scope.row.IsMyself"
                                    >{{ permission.removeOut }}</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="选择加入联盟的员工" :visible.sync="dialogStaffVisible" width="1000px">
            <div class="dialog-content" v-if="dialogStaffVisible">
                <MemberStaffChoose ref="staffChoose" @closeDialog="closeStaffDialog"></MemberStaffChoose>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="authTitle" :visible.sync="dialogAuthVisible" width="1000px">
            <div class="dialog-content" v-if="dialogAuthVisible">
                <UnionStaffAuthEdit ref="staffAuthEdit" :staffId="staffId" @closeDialog="closeAuthDialog"></UnionStaffAuthEdit>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import MemberStaffChoose from '@/components/entpUnion/entityManage/memberStaffChoose';
import UnionStaffAuthEdit from '@/components/entpUnion/entityManage/unionStaffAuthEdit';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'memberStaff',
    components: {
        elTableColumn,
        breadcrumb,
        MemberStaffChoose,
        UnionStaffAuthEdit
    },
    data() {
        return {
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                StaffName: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            loading: false,
            dateTimes: '',
            noData: false,
            authTitle: '',
            staffId: '',
            dialogStaffVisible: false,
            dialogAuthVisible: false,
            tableData: [],
            tableDataLength: 0,
            permission: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getUnionPermission('MemberStaffs');
        this.getTableData();
    },
    methods: {
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                StaffName: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            };
            this.dateTimes =[];
        },
        // 获取数据
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionMemberStaffList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        closeStaffDialog(isEdit) {
            this.dialogStaffVisible = false;
            if (isEdit) this.getTableData();
        },
        removeOut(item) {
            let that = this;
            if (item.StaffId) {
                that.$confirm('您确定要将【' + item.StaffName + '】移出联盟吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnions/RemoveOutUnionStaffs',
                                data: {
                                    UnionId: that.searchData.UnionId,
                                    StaffId: item.StaffId
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg('成功移出联盟');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        staffAuthEdit(item) {
            if (item) {
                this.authTitle = '为联盟人员【' + item.StaffName + '】分配权限';
                this.staffId = item.StaffId;
            }
            this.dialogAuthVisible = true;
        },
        closeAuthDialog() {
            this.dialogAuthVisible = false;
        }
    }
};
</script>
